module.exports = require('./helpers/bundle-url').getBundleURL('iVhRc') + "logo-dark.a922e36b.svg";